// The game server hosts the small HTTP APIs (telemetry, push) on the same host
// the client already uses for multiplayer.
const HOST = import.meta.env.VITE_PARTYKIT_HOST || 'localhost:1999';
const IS_LOCAL = /^(localhost|127\.0\.0\.1)(:\d+)?$/.test(HOST);

export const API_BASE = `${IS_LOCAL ? 'http' : 'https'}://${HOST}`;
